import fetch from '@/utils/fetch';
import { message } from 'antd';
import { ReportTypeEnum } from '../type';
import { VERIFY_STATUS_ENUM, GIVE_STATUS_ENUM, ADJUST_SALARY } from './type';
import filterNull from '@/utils/filterNull';

const model = {
  state: {
    searchParams: { page: 1, page_size: 20 },
    statics: {
      total: 0,
    },
    salarySearchParams: { page: 1, page_size: 20 },
    salaryTotal: 0,
    salaryTableData: [],
    punishSearchParams: { page: 1, page_size: 10 },
    punishTotal: 0,
    punishTableData: [],
    settleBaseData: {},
    tableLoading: false,
    settleReportData: [],
    carryReportData: [],
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { settleReport, basic }, getState }: any) => ({
    // tab切换时用于初始化参数
    initSearchParams(reportType: 0 | 1) {
      settleReport.setState({
        searchParams: {
          verify_status: undefined,
          page: 1,
          is_export_detail: 0,
          is_export: 0,
          give_status: undefined,
          settlement_batch: undefined,
          settlement_sn: undefined,
          start_date: undefined,
          end_date: undefined,
          is_clean: reportType,
        },
      });
    },

    async getSettleReportData(params = {}) {
      const searchParams = { ...getState().settleReport.searchParams, ...params };
      settleReport.setState({
        tableLoading: !searchParams.is_export && !searchParams.is_export_detail,
      });
      const data = await fetch('/saasmerchant/web/settlement/salary/settlement', {
        params: filterNull(searchParams),
        type: 'POST',
      });
      if (typeof data === 'boolean' && (searchParams.is_export || searchParams.is_export_detail)) {
        basic.setLogListDot(true);
        message.success('导出成功');
        return;
      }
      const savedReportData = getState().settleReport.settleReportData;
      const savedCarrryData = getState().settleReport.carryReportData;
      settleReport.setState({
        settleReportData: searchParams.is_clean ? savedReportData : (data && data.list) || [],
        carryReportData: searchParams.is_clean ? (data && data.list) || [] : savedCarrryData,
        searchParams,
        tableLoading: false,
        statics: {
          total: data && data.total,
        },
      });
    },
    async submitToAudit(settlement_sn: number) {
      return fetch('/saasmerchant/web/settlement/salary/toexamine', {
        params: filterNull({ settlement_sn }),
        type: 'POST',
      });
    },
    async auditSubmitResult(params: { settlement_sn: number; type: number; reason?: string }) {
      return fetch('/saasmerchant/web/settlement/salary/examine', {
        params: filterNull(params),
        type: 'POST',
        getAllResponseData: true,
      });
    },
    async giveSubmitAgain(settlement_sn: number) {
      return fetch('/saasmerchant/web/settlement/salary/resubmit', {
        params: filterNull({ settlement_sn }),
        type: 'POST',
      });
    },
    async getSettleBaseInfo(settlement_sn: number) {
      const res = await fetch('/saasmerchant/web/settlement/salary/settlementdetail', {
        params: filterNull({ settlement_sn }),
        type: 'POST',
      });
      settleReport.setState({
        settleBaseData: res || {},
      });
    },
    async getSalaryDetail(params: any) {
      const salarySearchParams = {
        ...getState().settleReport.salarySearchParams,
        ...(params || {}),
      };
      const data = await fetch('/saasmerchant/web/settlement/salary/salarydetail', {
        params: filterNull(salarySearchParams),
        type: 'POST',
      });
      settleReport.setState({
        salaryTableData: (data && data.list) || [],
        salaryTotal: data && data.total * 1,
        salarySearchParams,
      });
    },
    async getPunishDetail(params: any) {
      const punishSearchParams = {
        ...getState().settleReport.punishSearchParams,
        ...(params || {}),
      };
      const data = await fetch('/saasmerchant/web/settlement/salary/changedetail', {
        params: filterNull(punishSearchParams),
        type: 'POST',
      });
      settleReport.setState({
        punishTableData: ((data && data.list) || []).map(
          (item: Record<string, any>, i: number) => ({
            ...item,
            key: `${item.employee_id}_${i}`,
          }),
        ),
        punishTotal: data && data.total,
        punishSearchParams,
      });
    },
    async getEmployeeHourRange(params: any) {
      return fetch('/saasmerchant/web/settlement/salaryEmployeeSchedule/getTimeRange', {
        params,
        type: 'POST',
        useJson: true,
      });
    },
    async confirmAdjustEmployeeHourRange(params: any) {
      return fetch('/saasmerchant/web/settlement/salaryEmployeeSchedule/changeTimeRange', {
        params,
        type: 'POST',
        useJson: true,
        getAllResponseData: true,
      });
    },
    async adjustSalaryAmount(params: ADJUST_SALARY) {
      return fetch('/saasmerchant/web/settlement/salary/salarychange', {
        params: filterNull(params),
        type: 'POST',
        getAllResponseData: true,
      });
    },
    async addNewEmployeeSalary(params: { settlement_sn: number; data: JSON }) {
      return fetch('/saasmerchant/web/settlement/salary/addsalary', {
        params: filterNull(params),
        type: 'POST',
        getAllResponseData: true,
      });
    },
    async getEmployeebyName(params: { settlement_sn: string; employee_name: string }) {
      return fetch('/saasmerchant/web/settlement/salary/searchemployee', {
        params: filterNull(params),
        type: 'POST',
      });
    },

    async searchCompanyByName(params: { settlement_sn: string; company_name: string }) {
      const data = fetch('/saasmerchant/web/settlement/salary/searchcompany', {
        type: 'POST',
        params: filterNull(params),
      });
      return data;
    },

    async createTrashCarrySalaryList(params: { start_date: string; end_date: string }) {
      const data = fetch('/saasmerchant/web/settlement/salary/addSalarySettlement', {
        type: 'POST',
        params: filterNull(params),
      });
      return data;
    },
  }),
};

export const SETTLE_STATUS = [
  { value: VERIFY_STATUS_ENUM.ALL, label: '全部' },
  { value: VERIFY_STATUS_ENUM.WAIT_SUBMIT, label: '待提交' },
  { value: VERIFY_STATUS_ENUM.WAIT_AUDIT, label: '待审核' },
  { value: VERIFY_STATUS_ENUM.PASS, label: '审核通过' },
  { value: VERIFY_STATUS_ENUM.REJECT, label: '审核驳回' },
];

export const PROVIDE_STATUS = [
  { value: GIVE_STATUS_ENUM.ALL, label: '全部' },
  { value: GIVE_STATUS_ENUM.WAIT, label: '待发放' },
  { value: GIVE_STATUS_ENUM.SUCCESS, label: '成功' },
  { value: GIVE_STATUS_ENUM.FAIL, label: '失败' },
];

// 通过url传参，值不能改成number，如果修改到位了当然也能改
export const OPERATE_TYPE = {
  VIEW: '1',
  ADJUST: '2',
};

export default model;
